import PropTypes from "prop-types";

import BasicRender from "./BasicRender";

/**
 *
 * Component renders a list of editable templates of type gps
 */
const GPSRender = ({ gpsTemplate, onRemove, isEditable }) => {
  return (
    <BasicRender
      datasetTemplate={gpsTemplate}
      onRemove={onRemove}
      isEditable={isEditable}
    />
  );
};

GPSRender.propTypes = {
  gpsTemplate: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  isEditable: PropTypes.bool,
};

export default GPSRender;
